import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Home, BarChart3, UserCog, FileText, Bell, ChevronDown, Users, Globe, Clock, Info, ExternalLink, Check, Settings as SettingsIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function SettingsPage() {
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  // Notification Settings State
  const [notificationScope, setNotificationScope] = useState('account');
  const [gradingWeb, setGradingWeb] = useState(true);
  const [gradingEmail, setGradingEmail] = useState(true);
  const [gradingFrequency, setGradingFrequency] = useState('daily');
  const [updatesWeb, setUpdatesWeb] = useState(true);
  const [updatesEmail, setUpdatesEmail] = useState(false);
  const [updatesFrequency, setUpdatesFrequency] = useState('daily');
  const [activityWeb, setActivityWeb] = useState(true);
  const [activityEmail, setActivityEmail] = useState(true);
  const [activityFrequency, setActivityFrequency] = useState('daily');
  const [newQuestionWeb, setNewQuestionWeb] = useState(false);
  const [newQuestionEmail, setNewQuestionEmail] = useState(false);
  const [newQuestionFrequency, setNewQuestionFrequency] = useState('daily');
  const [newDiscussionWeb, setNewDiscussionWeb] = useState(false);
  const [newDiscussionEmail, setNewDiscussionEmail] = useState(false);
  const [newDiscussionFrequency, setNewDiscussionFrequency] = useState('daily');
  // Site Preferences State
  const [siteLanguage, setSiteLanguage] = useState('English');
  const [timezone, setTimezone] = useState('UTC-5');
  // Linked Accounts State
  const [linkedAccounts, setLinkedAccounts] = useState({
    apple: false,
    facebook: false,
    google: true,
    microsoft: false
  });
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
    };
    if (isUserMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen]);
  return <div className="flex-1 bg-gray-50 min-h-screen" data-id="element-2003">
      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200" data-id="element-2004">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2005">
          <div className="flex items-center h-16" data-id="element-2006">
            {/* Logo */}
            <div className="text-[#DB3725] font-bold text-xl" data-id="element-2007">LOGO</div>

            {/* Navigation Links */}
            <nav className="flex items-center gap-4 sm:gap-8 ml-6 sm:ml-12" data-id="element-2008">
              <Link to="/admin" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2009">
                <Home size={18} data-id="element-2010" />
                <span className="hidden sm:inline" data-id="element-2011">Admin Hub</span>
              </Link>
              <Link to="/analytics" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2012">
                <BarChart3 size={18} data-id="element-2013" />
                <span className="hidden sm:inline" data-id="element-2014">Analytics</span>
              </Link>
              <Link to="/feedback" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2015">
                <FileText size={18} data-id="element-2016" />
                <span className="hidden sm:inline" data-id="element-2017">Reports</span>
              </Link>
              <Link to="/assessment" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2018">
                <UserCog size={18} data-id="element-2019" />
                <span className="hidden sm:inline" data-id="element-2020">Users</span>
              </Link>
            </nav>

            {/* Right Side - User Info */}
            <div className="flex items-center gap-2 sm:gap-4 ml-auto" data-id="element-2021">
              <Link to="/alerts" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-2022">
                <Bell size={20} data-id="element-2023" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-2024"></span>
              </Link>
              <div className="relative" ref={userMenuRef} data-id="element-2025">
                <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-2026">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-2027">
                    LT
                  </div>
                  <span className="hidden sm:inline text-sm font-medium text-gray-900" data-id="element-2028">
                    Linda Taylor
                  </span>
                  <ChevronDown size={16} className="text-gray-600" data-id="element-2029" />
                </button>

                {isUserMenuOpen && <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-2030">
                    <div className="py-2" data-id="element-2031">
                      <Link to="/profile" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2032">
                        <Users size={18} className="text-gray-600" data-id="element-2033" />
                        <span className="font-medium text-gray-900" data-id="element-2034">
                          Profile
                        </span>
                      </Link>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2035">
                        <Home size={18} className="text-gray-600" data-id="element-2036" />
                        <span className="font-medium text-gray-900" data-id="element-2037">
                          Learner Hub
                        </span>
                      </button>
                      <Link to="/admin" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2038">
                        <UserCog size={18} className="text-gray-600" data-id="element-2039" />
                        <span className="font-medium text-gray-900" data-id="element-2040">
                          Admin Hub
                        </span>
                      </Link>
                      <Link to="/settings" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2041">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-2042">
                          <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" data-id="element-2043"></path>
                          <circle cx="12" cy="12" r="3" data-id="element-2044"></circle>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-2045">
                          Settings
                        </span>
                      </Link>
                      <div className="border-t border-gray-200 my-2" data-id="element-2046"></div>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2047">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-2048">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-2049"></path>
                          <polyline points="16 17 21 12 16 7" data-id="element-2050"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12" data-id="element-2051"></line>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-2052">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2053">
        {/* Header */}
        <div className="mb-8" data-id="element-2054">
          <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-2055">Settings</h1>
          <p className="text-gray-600" data-id="element-2056">
            Manage your notification preferences and account settings
          </p>
        </div>

        <div className="space-y-8" data-id="element-2057">
          {/* Notifications Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2058">
            <div className="p-6 border-b border-gray-200" data-id="element-2059">
              <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2060">
                Notifications
              </h2>
              <div className="text-sm text-gray-600 space-y-2" data-id="element-2061">
                <p data-id="element-2062">
                  Account-level settings apply to all courses. Notifications for
                  individual courses can be changed within each course and will
                  override account-level settings.
                </p>
                <p data-id="element-2063">
                  Daily notifications are delivered at 22:00 UTC. Weekly
                  notifications are delivered at 22:00 UTC Every Sunday.
                </p>
                <p className="text-[#30718D]" data-id="element-2064">
                  Notifications for certain activities are enabled by default,{' '}
                  <a href="#" className="underline hover:text-[#265a70]" data-id="element-2065">
                    as detailed here
                  </a>
                  <ExternalLink size={12} className="inline ml-1" data-id="element-2066" />
                </p>
              </div>
            </div>

            <div className="p-6" data-id="element-2067">
              {/* Notification Scope Selector */}
              <div className="mb-6" data-id="element-2068">
                <label className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-2069">
                  Select notifications for
                </label>
                <select value={notificationScope} onChange={e => setNotificationScope(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2070">
                  <option value="account" data-id="element-2071">Account</option>
                  <option value="course1" data-id="element-2072">Course 1</option>
                  <option value="course2" data-id="element-2073">Course 2</option>
                </select>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2074">
                  Applies to all courses
                </p>
              </div>

              {/* Notification Settings Table */}
              <div className="space-y-6" data-id="element-2075">
                {/* Grading */}
                <div data-id="element-2076">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-2077">
                    Grading
                  </h3>
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-2078">
                    <div className="flex-1" data-id="element-2079">
                      <span className="text-sm text-gray-700" data-id="element-2080">
                        Essay assignment grade received
                      </span>
                    </div>
                    <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2081">
                      <div className="flex items-center gap-2" data-id="element-2082">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2083">
                          Web
                        </span>
                        <button onClick={() => setGradingWeb(!gradingWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2084">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2085" />
                        </button>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2086">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2087">
                          Email
                        </span>
                        <button onClick={() => setGradingEmail(!gradingEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${gradingEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2088">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${gradingEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2089" />
                        </button>
                      </div>
                      <select value={gradingFrequency} onChange={e => setGradingFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2090">
                        <option value="daily" data-id="element-2091">Daily</option>
                        <option value="weekly" data-id="element-2092">Weekly</option>
                        <option value="immediately" data-id="element-2093">Immediately</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Updates */}
                <div data-id="element-2094">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-2095">
                    Updates
                  </h3>
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-2096">
                    <div className="flex-1" data-id="element-2097">
                      <span className="text-sm text-gray-700" data-id="element-2098">
                        Course updates
                      </span>
                    </div>
                    <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2099">
                      <div className="flex items-center gap-2" data-id="element-2100">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2101">
                          Web
                        </span>
                        <button onClick={() => setUpdatesWeb(!updatesWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2102">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2103" />
                        </button>
                      </div>
                      <div className="flex items-center gap-2" data-id="element-2104">
                        <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2105">
                          Email
                        </span>
                        <button onClick={() => setUpdatesEmail(!updatesEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${updatesEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2106">
                          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${updatesEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2107" />
                        </button>
                      </div>
                      <select value={updatesFrequency} onChange={e => setUpdatesFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2108">
                        <option value="daily" data-id="element-2109">Daily</option>
                        <option value="weekly" data-id="element-2110">Weekly</option>
                        <option value="immediately" data-id="element-2111">Immediately</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Discussions */}
                <div data-id="element-2112">
                  <h3 className="text-base font-bold text-gray-900 mb-3" data-id="element-2113">
                    Discussions
                  </h3>
                  <div className="space-y-3" data-id="element-2114">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-2115">
                      <div className="flex-1 flex items-center gap-2" data-id="element-2116">
                        <span className="text-sm text-gray-700" data-id="element-2117">
                          Activity notifications
                        </span>
                        <Info size={14} className="text-gray-400" data-id="element-2118" />
                      </div>
                      <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2119">
                        <div className="flex items-center gap-2" data-id="element-2120">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2121">
                            Web
                          </span>
                          <button onClick={() => setActivityWeb(!activityWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2122">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2123" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-2124">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2125">
                            Email
                          </span>
                          <button onClick={() => setActivityEmail(!activityEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${activityEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2126">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${activityEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2127" />
                          </button>
                        </div>
                        <select value={activityFrequency} onChange={e => setActivityFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2128">
                          <option value="daily" data-id="element-2129">Daily</option>
                          <option value="weekly" data-id="element-2130">Weekly</option>
                          <option value="immediately" data-id="element-2131">Immediately</option>
                        </select>
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 border-b border-gray-100 gap-3" data-id="element-2132">
                      <div className="flex-1" data-id="element-2133">
                        <span className="text-sm text-gray-700" data-id="element-2134">
                          New question posts
                        </span>
                      </div>
                      <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2135">
                        <div className="flex items-center gap-2" data-id="element-2136">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2137">
                            Web
                          </span>
                          <button onClick={() => setNewQuestionWeb(!newQuestionWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2138">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2139" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-2140">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2141">
                            Email
                          </span>
                          <button onClick={() => setNewQuestionEmail(!newQuestionEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newQuestionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2142">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newQuestionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2143" />
                          </button>
                        </div>
                        <select value={newQuestionFrequency} onChange={e => setNewQuestionFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2144">
                          <option value="daily" data-id="element-2145">Daily</option>
                          <option value="weekly" data-id="element-2146">Weekly</option>
                          <option value="immediately" data-id="element-2147">Immediately</option>
                        </select>
                      </div>
                    </div>

                    <div className="flex flex-col sm:flex-row sm:items-center justify-between py-3 gap-3" data-id="element-2148">
                      <div className="flex-1" data-id="element-2149">
                        <span className="text-sm text-gray-700" data-id="element-2150">
                          New discussion posts
                        </span>
                      </div>
                      <div className="flex items-center gap-4 sm:gap-8 flex-wrap" data-id="element-2151">
                        <div className="flex items-center gap-2" data-id="element-2152">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2153">
                            Web
                          </span>
                          <button onClick={() => setNewDiscussionWeb(!newDiscussionWeb)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionWeb ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2154">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionWeb ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2155" />
                          </button>
                        </div>
                        <div className="flex items-center gap-2" data-id="element-2156">
                          <span className="text-xs font-medium text-gray-500 w-8" data-id="element-2157">
                            Email
                          </span>
                          <button onClick={() => setNewDiscussionEmail(!newDiscussionEmail)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${newDiscussionEmail ? 'bg-[#007558]' : 'bg-gray-300'}`} data-id="element-2158">
                            <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${newDiscussionEmail ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-2159" />
                          </button>
                        </div>
                        <select value={newDiscussionFrequency} onChange={e => setNewDiscussionFrequency(e.target.value)} className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2160">
                          <option value="daily" data-id="element-2161">Daily</option>
                          <option value="weekly" data-id="element-2162">Weekly</option>
                          <option value="immediately" data-id="element-2163">Immediately</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Site Preferences Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2164">
            <div className="p-6 border-b border-gray-200" data-id="element-2165">
              <h2 className="text-xl font-bold text-gray-900" data-id="element-2166">
                Site Preferences
              </h2>
            </div>

            <div className="p-6 space-y-6" data-id="element-2167">
              {/* Site Language */}
              <div data-id="element-2168">
                <div className="flex items-center gap-2 mb-2" data-id="element-2169">
                  <label className="text-sm font-semibold text-gray-900" data-id="element-2170">
                    Site language
                  </label>
                  <button className="text-[#30718D] hover:text-[#265a70]" data-id="element-2171">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[#30718D]" data-id="element-2172">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" data-id="element-2173"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" data-id="element-2174"></path>
                    </svg>
                  </button>
                </div>
                <select value={siteLanguage} onChange={e => setSiteLanguage(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2175">
                  <option value="English" data-id="element-2176">English</option>
                  <option value="Spanish" data-id="element-2177">Español</option>
                  <option value="French" data-id="element-2178">Français</option>
                  <option value="German" data-id="element-2179">Deutsch</option>
                </select>
                <p className="text-xs text-gray-500 mt-1" data-id="element-2180">
                  The language used throughout this site. This site is currently
                  available in a limited number of languages.
                </p>
              </div>

              {/* Time Zone */}
              <div data-id="element-2181">
                <div className="flex items-center gap-2 mb-2" data-id="element-2182">
                  <label className="text-sm font-semibold text-gray-900" data-id="element-2183">
                    Time zone
                  </label>
                  <button className="text-[#30718D] hover:text-[#265a70]" data-id="element-2184">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-[#30718D]" data-id="element-2185">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" data-id="element-2186"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" data-id="element-2187"></path>
                    </svg>
                  </button>
                </div>
                <button className="text-[#30718D] text-sm font-medium hover:text-[#265a70] mb-2" data-id="element-2188">
                  Set time zone
                </button>
                <p className="text-xs text-gray-500" data-id="element-2189">
                  Select the time zone for displaying course dates. If you do
                  not specify a time zone, course dates, including assignment
                  deadlines, will be displayed in your browser's local time
                  zone.
                </p>
              </div>
            </div>
          </motion.div>

          {/* Linked Accounts Section */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-2190">
            <div className="p-6 border-b border-gray-200" data-id="element-2191">
              <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2192">
                Linked Accounts
              </h2>
              <p className="text-sm text-gray-600" data-id="element-2193">
                You can link your identity accounts to simplify signing in to
                edX.
              </p>
            </div>

            <div className="p-6 space-y-4" data-id="element-2194">
              {/* Apple */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2195">
                <div data-id="element-2196">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2197">
                    Apple
                  </div>
                  {linkedAccounts.apple && <div className="text-xs text-gray-500" data-id="element-2198">
                      Linked account: user@icloud.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                apple: !linkedAccounts.apple
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2199">
                  {linkedAccounts.apple ? 'Unlink' : 'Sign in with Apple'}
                </button>
              </div>

              {/* Facebook */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2200">
                <div data-id="element-2201">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2202">
                    Facebook
                  </div>
                  {linkedAccounts.facebook && <div className="text-xs text-gray-500" data-id="element-2203">
                      Linked account: user@facebook.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                facebook: !linkedAccounts.facebook
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2204">
                  {linkedAccounts.facebook ? 'Unlink' : 'Sign in with Facebook'}
                </button>
              </div>

              {/* Google */}
              <div className="flex items-center justify-between py-3 border-b border-gray-100" data-id="element-2205">
                <div data-id="element-2206">
                  <div className="flex items-center gap-2 mb-1" data-id="element-2207">
                    <span className="text-sm font-semibold text-gray-900" data-id="element-2208">
                      Google
                    </span>
                    <span className="px-2 py-0.5 bg-[#007558]/10 text-[#007558] text-xs font-medium rounded" data-id="element-2209">
                      Linked
                    </span>
                  </div>
                  {linkedAccounts.google && <div className="text-xs text-gray-500" data-id="element-2210">
                      Linked account: linda.taylor@gmail.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                google: !linkedAccounts.google
              })} className="px-4 py-2 text-[#30718D] hover:bg-[#30718D]/10 rounded-lg text-sm font-medium transition-colors" data-id="element-2211">
                  Unlink Google account
                </button>
              </div>

              {/* Microsoft */}
              <div className="flex items-center justify-between py-3" data-id="element-2212">
                <div data-id="element-2213">
                  <div className="text-sm font-semibold text-gray-900 mb-1" data-id="element-2214">
                    Microsoft
                  </div>
                  {linkedAccounts.microsoft && <div className="text-xs text-gray-500" data-id="element-2215">
                      Linked account: user@outlook.com
                    </div>}
                </div>
                <button onClick={() => setLinkedAccounts({
                ...linkedAccounts,
                microsoft: !linkedAccounts.microsoft
              })} className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors" data-id="element-2216">
                  {linkedAccounts.microsoft ? 'Unlink' : 'Sign in with Microsoft'}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}